import { useCallback } from "react";

const useFileDownload = (fetchFile: any) => {
  const downloadFile = useCallback(
    async (params: any) => {
      try {
        const { blob, fileName } = await fetchFile(params).unwrap();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error("File download failed:", error);
      }
    },
    [fetchFile],
  );

  return { downloadFile };
};

export default useFileDownload;
